<template>
    <v-dialog v-model="SHOW" persistent>
        <div class="graph_fullscreen">
            <header>
                <h1>{{DATA.nome}}</h1>
                <label title="Indietro" @click="go_back">
                    <GraphSVG name="arrow_left" />
                </label>
                <label title="Visualizza Tabella" @click="emit(10)">
                    <GraphSVG name='table'/>
                </label>
                <label title="Visualizza query compilata" @click="emit(9)" v-if="isAdmin()">
                    <GraphSVG name='database_cog'/>
                </label>
                <label title="Grafico derivato" v-if="isAdmin()" @click="emit(8)">
                    <GraphSVG name='math_function' />
                </label>                
            </header>
            <main>
                <div :data-hide="LOADED">
                    <svg style="shape-rendering: auto;" width="120px" height="100%" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                        <rect x="17.5" y="30" width="15" height="40">
                            <animate attributeName="y" repeatCount="indefinite" dur="1s" calcMode="spline" keyTimes="0;0.5;1" values="18;30;30" keySplines="0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.2s"></animate>
                            <animate attributeName="height" repeatCount="indefinite" dur="1s" calcMode="spline" keyTimes="0;0.5;1" values="64;40;40" keySplines="0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.2s"></animate>
                        </rect>
                        <rect x="42.5" y="30" width="15" height="40">
                            <animate attributeName="y" repeatCount="indefinite" dur="1s" calcMode="spline" keyTimes="0;0.5;1" values="20.999999999999996;30;30" keySplines="0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.1s"></animate>
                            <animate attributeName="height" repeatCount="indefinite" dur="1s" calcMode="spline" keyTimes="0;0.5;1" values="58.00000000000001;40;40" keySplines="0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.1s"></animate>
                        </rect>
                        <rect x="67.5" y="30" width="15" height="40">
                            <animate attributeName="y" repeatCount="indefinite" dur="1s" calcMode="spline" keyTimes="0;0.5;1" values="20.999999999999996;30;30" keySplines="0 0.5 0.5 1;0 0.5 0.5 1"></animate>
                            <animate attributeName="height" repeatCount="indefinite" dur="1s" calcMode="spline" keyTimes="0;0.5;1" values="58.00000000000001;40;40" keySplines="0 0.5 0.5 1;0 0.5 0.5 1"></animate>
                        </rect>
                    </svg>
                </div>
                 <Grafico index="fullscreen"/>
            </main>           
        </div>
    </v-dialog>
</template>
<script>
import Grafico from "@/components/GRAPH/Grafici/Grafici.vue";
import GraphSVG from "@/components/GRAPH/Generale/Componenti/SVG/SVG.vue";
export default {
    name : "GraphFullscreen",
    components:{
        Grafico,
        GraphSVG
    },
    data(){
        return{
            history : null,
            SHOW : false,
            DATA : {},
            TIME_HANDLER : null,
            LOADED : false,
        }
    },
    mounted(){
        document.body.addEventListener('graph_fullscreen',this.show_fullscreen);
    },
    beforeDestroy(){
        document.body.removeEventListener('graph_fullscreen',this.show_fullscreen);
    },
    destroyed(){ /*window.freeComponent(this);*/ },
    methods:{
        isAdmin(){
            return Number(localStorage.id_profilo)==1;
        },
        emit(event_code){
            let event = new CustomEvent('widget_event',{detail:{
                widget : this.DATA,
                code : event_code
            }});
            document.body.dispatchEvent(event);
        },
        build(){
            const that = this;
            this.TIME_HANDLER = setInterval(function(){
                let target =  document.getElementById('chart-fullscreen');
                if(target==null||target==undefined){return;}
                let update_event = new CustomEvent('graph_update',{detail:that.DATA});
                let resize_event = new CustomEvent('graph_resize',{detail:that.DATA});
                target.dispatchEvent(update_event);                
                target.dispatchEvent(resize_event);
                clearInterval(that.TIME_HANDLER);
                that.LOADED = true;               
            },100);
        },
        show_fullscreen(data){
            if(this.history == null){ 
                this.history = new Array(); 
            }else{
                this.history.push(this.DATA);
            }

            data = data.detail;
            this.DATA = data;
            this.SHOW = true;

            this.build();             
        },
        go_back(){
            const item = this.history.pop();
            if(item == undefined){
                this.SHOW = false;
                this.LOADED = false;
                this.history = null;
            }else{
                this.DATA = item;
                this.build();
            }             
        }
    }
}
</script>
<style src="./Fullscreen.css" scoped></style>